import React, { Fragment, useState } from 'react';
import SubLedgerListView from '../../../components/account/setup/sub_ledg/SubLedgerListView';
import AppURL from '../../../constants/AppURL';
import useFetchData from '../../../helpers/useFetch';

const SubLedgerCreateListView = () => {
    const [onURL, setOnURL] = useState(AppURL.AccountURL + 'account/sub/ledger/ledger/list/view/');
    const { data, loading, error, refetch } = useFetchData(onURL);
    const handleFormSuccess = (): void => {
        refetch();
    };
  return (
    <Fragment>
        <SubLedgerListView setOnURL={setOnURL} handleFormSuccess={handleFormSuccess} results={data} loading={loading} error={error} />
    </Fragment>
  )
}

export default SubLedgerCreateListView